import React from 'react';
import { Button } from '../ui/Button';
import { ArrowDown } from 'lucide-react';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-gradient-to-b from-emerald-50 to-white py-12 md:py-20 px-4" data-id="element-46">
      <div className="max-w-4xl mx-auto text-center" data-id="element-47">
        <div className="inline-block bg-emerald-100 text-emerald-800 px-4 py-1 rounded-full text-sm font-bold mb-6 uppercase tracking-wide" data-id="element-48">
          Método natural para controlar su azúcar en sangre
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 mb-6 leading-tight" data-id="element-49">
          Descubra el{' '}
          <span className="text-emerald-700" data-id="element-50">"Enjuague de Páncreas"</span> de 7
          Días
        </h1>

        <p className="text-xl md:text-2xl text-gray-700 mb-8 max-w-3xl mx-auto leading-relaxed" data-id="element-51">
          Está ayudando a los uruguayos a estabilizar su azúcar de forma
          natural,{' '}
          <span className="font-bold text-gray-900 bg-yellow-100 px-1" data-id="element-52">
            sin abandonar el asado ni depender de la farmacia.
          </span>
        </p>

        <div className="mb-10" data-id="element-53">
          <img src="https://cdn.magicpatterns.com/uploads/swco9uh88fgzGaxD6EYQFz/Mockup.png" alt="El Protocolo de Limpieza Glicémica - Mockup Digital" className="w-full max-w-lg mx-auto drop-shadow-2xl rounded-lg transform hover:scale-105 transition-transform duration-500" data-id="element-54" />
          <p className="text-sm text-gray-500 mt-2 italic" data-id="element-55">
            Disponible en formato digital PDF - Descarga Inmediata
          </p>
        </div>

        <div className="flex flex-col items-center gap-4" data-id="element-56">
          <Button variant="primary" size="xl" onClick={scrollToOffer} className="shadow-emerald-200 shadow-lg animate-bounce-slow" data-id="element-57">
            SÍ, QUIERO LIMPIAR MI PÁNCREAS AHORA
          </Button>
          <div className="flex items-center text-gray-500 text-sm" data-id="element-58">
            <ArrowDown className="h-4 w-4 mr-1" data-id="element-59" />
            <span data-id="element-60">Lea la historia completa abajo</span>
          </div>
        </div>
      </div>
    </section>;
}